var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6425 10.402C13.8647 10.1404 14 9.79525 14 9.41758C14 8.6035 13.3719 7.94102 12.6 7.94102H9.88276C10.1519 7.07969 10.2667 5.93683 10.2667 5.44694V4.95508C10.2667 3.86964 9.42916 2.98633 8.4 2.98633H7.93333C7.71929 2.98633 7.53262 3.13989 7.48067 3.35908L7.22649 4.43172C6.87027 5.93387 5.73938 7.59123 4.56898 7.89245C4.36396 7.34514 3.85778 6.95664 3.26667 6.95664H0.466667C0.209067 6.95664 0 7.17714 0 7.44883V16.3082C0 16.5799 0.209067 16.8004 0.466667 16.8004H3.26667C3.82324 16.8004 4.30484 16.4562 4.5304 15.9587L6.13387 16.5225C6.65809 16.7069 7.2044 16.8004 7.75724 16.8004H11.6667C12.4385 16.8004 13.0667 16.1379 13.0667 15.3238C13.0667 15.1319 13.0318 14.9481 12.9684 14.7798C13.562 14.6088 14 14.035 14 13.3551C14 12.9774 13.8647 12.6322 13.6425 12.3707C13.8647 12.1092 14 11.764 14 11.3863C14 11.0087 13.8647 10.6635 13.6425 10.402ZM3.73333 15.3238C3.73333 15.5952 3.52396 15.816 3.26667 15.816H0.933333V7.94102H3.26667C3.52396 7.94102 3.73333 8.16184 3.73333 8.4332V15.3238ZM11.6667 10.8941H12.6C12.8573 10.8941 13.0667 11.115 13.0667 11.3863C13.0667 11.6577 12.8573 11.8785 12.6 11.8785H11.6667C11.4091 11.8785 11.2 12.099 11.2 12.3707C11.2 12.6424 11.4091 12.8629 11.6667 12.8629H12.6C12.8573 12.8629 13.0667 13.0837 13.0667 13.3551C13.0667 13.6264 12.8573 13.8473 12.6 13.8473H11.6667C11.4091 13.8473 11.2 14.0678 11.2 14.3395C11.2 14.6111 11.4091 14.8316 11.6667 14.8316C11.924 14.8316 12.1333 15.0525 12.1333 15.3238C12.1333 15.5952 11.924 15.816 11.6667 15.816H7.75724C7.30489 15.816 6.85782 15.7396 6.4288 15.5886L4.66667 14.9691V8.8788C5.39871 8.73212 6.1152 8.24322 6.762 7.44292C7.39356 6.66133 7.90564 5.62511 8.13182 4.67059L8.29764 3.9707H8.4C8.91458 3.9707 9.33333 4.41236 9.33333 4.95508V5.44694C9.33333 6.10778 9.13733 7.37533 8.88658 7.94102H7.93333C7.67573 7.94102 7.46667 8.16152 7.46667 8.4332C7.46667 8.70489 7.67573 8.92539 7.93333 8.92539H12.6C12.8573 8.92539 13.0667 9.14622 13.0667 9.41758C13.0667 9.68894 12.8573 9.90977 12.6 9.90977H11.6667C11.4091 9.90977 11.2 10.1303 11.2 10.402C11.2 10.6736 11.4091 10.8941 11.6667 10.8941Z",
    fill: "url(#paint0_linear_2028_593)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86706 0C8.60933 0 8.40039 0.220369 8.40039 0.492187V1.50937C8.40039 1.78119 8.60933 2.00156 8.86706 2.00156C9.12478 2.00156 9.33372 1.78119 9.33372 1.50937V0.492187C9.33372 0.220369 9.12478 0 8.86706 0Z",
    fill: "url(#paint1_linear_2028_593)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88629 2.17029L6.22633 1.47424C6.04412 1.28202 5.74862 1.28202 5.56637 1.47424C5.38413 1.66646 5.38413 1.97808 5.56637 2.17029L6.22633 2.86634C6.40855 3.05853 6.70408 3.05856 6.88629 2.86634C7.06854 2.67413 7.06854 2.36251 6.88629 2.17029Z",
    fill: "url(#paint2_linear_2028_593)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1666 1.47424C11.9843 1.28202 11.6889 1.28202 11.5066 1.47424L10.8466 2.17026C10.6644 2.36247 10.6644 2.67409 10.8466 2.86631C11.0289 3.05853 11.3244 3.05856 11.5066 2.86634L12.1666 2.17029C12.3488 1.97808 12.3488 1.66646 12.1666 1.47424Z",
    fill: "url(#paint3_linear_2028_593)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2028_593",
    x1: 18.8821,
    y1: 14.2811,
    x2: 13.195,
    y2: 21.2471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2028_593",
    x1: 9.65919,
    y1: 1.63653,
    x2: 8.93973,
    y2: 2.04201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2028_593",
    x1: 7.57859,
    y1: 2.70403,
    x2: 6.87901,
    y2: 3.50573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2028_593",
    x1: 12.8589,
    y1: 2.70402,
    x2: 12.1593,
    y2: 3.50572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumb-up.29201f6b1fecd93bd995fb643f59456a.svg";
export { ForwardRef as ReactComponent };